import { Dispatch } from "redux";

import { EmployeeStateAction } from "@reducers/types/inventory/employee-state";

import {
  getEmployees,
  getEmployee,
  getEmployeeGeneralInfo,
  getEmployeeAssets,
  assignDeskOrBed,
} from "@api/inventory/employee";

import {
  GET_EMPLOYEE,
  GET_SINGLE_EMPLOYEE,
  GET_EMPLOYEE_GENERAL_INFO,
  GET_EMPLOYEE_ASSETS,
  ASSIGN_EMPLOYEE_DESK_0R_BED,
} from "./types";
import { EmployeeAssignDeskOrBedType } from "@type/inventory/employee";

export const fetchEmployees = (query: any) => async (
  dispatch: Dispatch<EmployeeStateAction>
) => {
  dispatch({ type: GET_EMPLOYEE.LOADING, payload: true });

  try {
    const res = await getEmployees(query);

    const { data, page, size, total } = res.data || {};

    dispatch({
      type: GET_EMPLOYEE.SUCCESS,
      payload: {
        data,
        pagination: {
          page,
          size,
          total,
        },
      },
    });
  } catch (err) {
    dispatch({ type: GET_EMPLOYEE.ERROR, payload: null });
  }
};

export const fetchEmployee = (id: string | number) => async (
  dispatch: Dispatch<EmployeeStateAction>
) => {
  dispatch({ type: GET_SINGLE_EMPLOYEE.LOADING, payload: true });

  try {
    const res = await getEmployee(id);

    dispatch({
      type: GET_SINGLE_EMPLOYEE.SUCCESS,
      payload: res.data || {},
    });
  } catch (err) {
    dispatch({ type: GET_SINGLE_EMPLOYEE.ERROR, payload: err });
  }
};

export const fetchEmployeeGeneralInfoActionHandler = (
  id: string | number
) => async (dispatch: Dispatch<EmployeeStateAction>) => {
  dispatch({ type: GET_EMPLOYEE_GENERAL_INFO.LOADING, payload: true });

  try {
    const res = await getEmployeeGeneralInfo(id);

    dispatch({
      type: GET_EMPLOYEE_GENERAL_INFO.SUCCESS,
      payload: {
        data: res.data || null,
      },
    });
  } catch (err) {
    dispatch({ type: GET_EMPLOYEE_GENERAL_INFO.ERROR, payload: err });
  }
};

export const fetchEmployeeAssetsActionHandler = (
  id: string | number,
  query: any
) => async (dispatch: Dispatch<EmployeeStateAction>) => {
  dispatch({ type: GET_EMPLOYEE_ASSETS.LOADING, payload: true });

  try {
    const res = await getEmployeeAssets(id, query);

    const { data, page, size, total } = res.data || {};

    dispatch({
      type: GET_EMPLOYEE_ASSETS.SUCCESS,
      payload: {
        data,
        pagination: {
          page,
          size,
          total,
        },
      },
    });
  } catch (err) {
    dispatch({ type: GET_EMPLOYEE_ASSETS.ERROR, payload: err });
  }
};

export const assignEmployeeDeskOrBedActionHandler = (
  id: string | number,
  data: EmployeeAssignDeskOrBedType
) => async (dispatch: Dispatch<EmployeeStateAction>) => {
  dispatch({ type: ASSIGN_EMPLOYEE_DESK_0R_BED.LOADING, payload: true });

  try {
    const res = await assignDeskOrBed(id, data);

    dispatch({
      type: ASSIGN_EMPLOYEE_DESK_0R_BED.SUCCESS,
      payload: res.data || {},
    });
  } catch (err) {
    dispatch({ type: ASSIGN_EMPLOYEE_DESK_0R_BED.ERROR, payload: err });
  }
};
